import React from "react";

interface Props {
  txt: string;
  disabled?: boolean;
  handleClick?: () => void;
}

const RoundBtn: React.FC<Props> = ({ txt, disabled, handleClick }) => {
  return (
    <div className={`round-button-wrapper`}>
      <button type="button" onClick={handleClick} disabled={disabled}>
        {txt}
      </button>
    </div>
  );
};

export default RoundBtn;
